import * as React from "react";
import { observer } from "mobx-react-lite";
import type { PartialAnticipationShelf } from "../../shelves";
import { PartialAnticipationResume, PartialAnticipationForm } from "../";

interface IProps {
	partialAnticipationShelf: PartialAnticipationShelf;
	isLoading: boolean;
	onSelectFGTSValue(): Promise<void>;
	onEditFGTSValue(): void;
	onConfirmFGTSValue(): void;
	currentComponentControl(): void;
}

export const PartialAnticipation: React.FC<IProps> = observer((props) => {
	const { partialAnticipationShelf, onSelectFGTSValue, onEditFGTSValue, onConfirmFGTSValue, isLoading, currentComponentControl } = props;

	return partialAnticipationShelf.hasSelectedFGTSAnticipationValue.value ? (
		<PartialAnticipationResume
			isLoading={isLoading}
			partialAnticipationShelf={partialAnticipationShelf}
			onConfirmFGTSValue={onConfirmFGTSValue}
			onEditFGTSValue={onEditFGTSValue}
		/>
	) : (
		<PartialAnticipationForm
			currentComponentControl={currentComponentControl}
			partialAnticipationShelf={partialAnticipationShelf}
			isLoading={isLoading}
			onSubmit={async () => onSelectFGTSValue()}
		/>
	);
});
